// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + ({"702":"story","715":"list","962":"home"}[chunkId] || chunkId) + "-" + {"137":"8f1952ff70d3f8ea3634","702":"0a983a4641dcdb29ae0c","715":"8b438432ba5b7217e530","935":"867a917fe6fb7383e6e4","962":"6fc8856de5190092d66f"}[chunkId] + ".css";
};